export var PeoplePickerItemStyles = function (props) {
    var selected = props.selected, theme = props.theme;
    var palette = theme.palette;
    return {
        removeButton: [
            {
                background: 'transparent',
                selectors: {
                    ':active': {
                        color: palette.white,
                        backgroundColor: palette.themeDark,
                    },
                },
            },
            !selected && {
                color: palette.neutralPrimary,
            },
            selected && {
                color: palette.white,
            },
        ],
    };
};
//# sourceMappingURL=PeoplePicker.styles.js.map